import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectChecklistColorClassPipe } from '@portal-core/project-checklists/pipes/project-checklist-color-class/project-checklist-color-class.pipe';

@NgModule({
  declarations: [ProjectChecklistColorClassPipe],
  imports: [CommonModule],
  exports: [ProjectChecklistColorClassPipe],
  providers: [ProjectChecklistColorClassPipe]
})
export class ProjectChecklistColorClassModule { }
